import React, { useCallback } from 'react'
import { Column } from '@sencha/ext-modern'

import { genHtml } from 'tyan/public/components/Form/Block/base/MultiLines/rteFuns'

const renderInner = (value, record, dataIndex, cell, column) => {
	const { config: { maxHeight, tooltipDelay, wrapperStyle } = {} } = column || {}
	value = genHtml(value)

	const style = { ...wrapperStyle || {}/* width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', display: 'flex', flexDirection: 'column'  */ }
	maxHeight && (style.maxHeight = `${maxHeight}px`)
	return <div className='t-gridrichtext'
		{...(tooltipDelay < 0 ? {} : {
			'data-qshowdelay': tooltipDelay === 0 ? 0 : tooltipDelay || 1000,
			'data-qtip': `<div class='t-gridrichtext' style='max-height:88vh; max-width:90vw; overflow:auto'>${value}</div>`,
			'data-qanchor': true,
			'data-qdismissdelay': 0,
			'data-qallowover': true,
			'data-qcls': 't-gridrichtext'
		})}

		// data-qhideDelay={0}
		// data-qoverflow={true}
		style={style}
		dangerouslySetInnerHTML={{ __html: value }}
	/>
}

const render = ({ _richtext: text, dataIndex, ...rest }) => {

	return <Column {...{ dataIndex, text, renderer: renderInner, ...rest }} />
}

export default render